import React, { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { PageLoader } from "../common/Loaders/PageLoader";
import { savePendingDeepLink } from "../../utils/deepLink";
import { useRequireAuth } from "../../contexts/AuthPromptContext";

/**
 * Soft-gates auth-only routes for guests: saves the deep link, opens
 * "Sign in to continue", and sends the user to Home.
 */
const SoftGateAuthRedirect: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { promptSignIn } = useRequireAuth();
  const didRun = useRef(false);

  useEffect(() => {
    if (didRun.current) {
      return;
    }
    didRun.current = true;
    savePendingDeepLink(`${location.pathname}${location.search}`);
    promptSignIn();
    navigate("/", { replace: true });
  }, [location.pathname, location.search, navigate, promptSignIn]);

  return <PageLoader />;
};

export default SoftGateAuthRedirect;
